






















































import SimpleMap from '../../core/components/SimpleMap.vue';
import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray,
    TypeParams,
    getIdsFromList,
    getDictionaryKeyByValue
} from '../../core/utils';
import { Destroyed } from '../../core/decorators';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import Button from '../../core/components/Button.vue';
import Combobox from '../../core/components/Combobox.vue';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import { InsuranceServices } from '../api/InsuranceServices';
import Loading from 'vue-loading-overlay';
import { ranchsCropTypeBulk } from '../ranch';
import { farmingTypeOptions, farmingTypesDict, getFarmingKeyByType, harvestFarmingTypeText, sowingFarmingTypeText } from '../helpers';

@Component({
    components: {
        Loading,
        SimpleMap,
        Combobox,
        Button,
    }
})
export default class ModalRanchAssignCropType extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop({default: false}) visible: boolean;
    @Prop({default: false}) isSowing: boolean;
    @Prop({default(){return []}}) selectedRanchs: Array<object>;
    @Prop({default(){return []}}) cropTypes: Array<object>;
    cropTypeSelected: object | null = null;
    cropTypeRV: boolean = false;
    pendingRequest: boolean = false;

    getRanchIds(){
        if(this.isSowing){
            return getIdsFromList(this.selectedRanchs)
        }
        return this.selectedRanchs.map(item => item['properties']['ranch_id'])
    }

    updateCropTypeSelected(value){
        this.cropTypeSelected = value;
    }

    updateCropTypeRV(value){
        this.cropTypeRV = value;
    }

    showLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }
    showSuccessLoadingDialog(response, alternative_msg){
        this.$_successLoadingDialog({
            response: response,
            alternative_msg: alternative_msg
        });
        this.closeModal();
    }
    showCatchLoadingDialog(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }

    assignCropType() {
        this.pendingRequest = true;
        this.showLoadingDialog('Guardando Nota...');
        InsuranceServices.addCropTypeToMultipleRanchs(this.getData)
            .then(res => {
                this.showSuccessLoadingDialog(res, '');
                this.updateFarmingDetail();
            })
            .catch(err => {
                this.showCatchLoadingDialog(err, 'No se pudo asignar el tipo de cultivo');
            }).finally(() => {
                this.pendingRequest = false
            })
    }

    get formIsValid(){
        if(this.cropTypeSelected == null){
            return false
        }
        return true
    }

    get getRanchType(){
        let farmingTypeText = this.isSowing ? sowingFarmingTypeText: harvestFarmingTypeText
        return getDictionaryKeyByValue(this.$_getInsuranceProperties['ranch_types'], farmingTypeText) || 0 
    }

    get getData():ranchsCropTypeBulk {
        return {
            [TypeParams.RANCH_IDS]: this.getRanchIds(),
            [TypeParams.CROP_TYPE]: this.cropTypeSelected ? Number(this.cropTypeSelected['id']) : 0,
            [TypeParams.RANCH_TYPE]: this.getRanchType as number
        };
    }

    @Emit()
    closeModal() {}

    @Emit()
    updateFarmingDetail() {}

    mounted() {}
}
